import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    '& label.Mui-disabled': {
      color: '#282828'
    },
    '& input:disabled': {
      color: '#282828'
    },
    '& .Mui-disabled fieldset': {
      borderColor: 'transparent !important'
    },
    '& .Mui-disabled .MuiInputAdornment-root': {
      display: 'none'
    },
    '& .MuiInputBase-marginDense.MuiOutlinedInput-adornedEnd': {
      paddingRight: '0'
    }
  }
}));

const CustomTimePicker = props => {
  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <TimePicker
        {...props}
        ampm={false}
        fullWidth
        inputVariant="outlined"
        size="small"
        className={classes.root}
      />
    </MuiPickersUtilsProvider>
  );
};

export default CustomTimePicker;
